import React from 'react'

export default () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3108_3886)">
        <rect width="44" height="44" fill="white" />
        <rect width="44" height="44" fill="#032942" />
        <g>
          <circle
            cx="3.04192"
            cy="4.4431"
            r="0.770436"
            fill="#61DFBD"
          />
          <circle
            cx="3.01961"
            cy="4.35371"
            r="0.770436"
            transform="rotate(-169.064 3.01961 4.35371)"
            fill="#61DFBD"
          />
          <circle
            cx="12.5995"
            cy="3.21344"
            r="0.770436"
            transform="rotate(-141.388 12.5995 3.21344)"
            fill="#61DFBD"
          />
          <circle
            cx="27.3475"
            cy="7.06964"
            r="0.770436"
            transform="rotate(-141.388 27.3475 7.06964)"
            fill="#61DFBD"
          />
          <circle
            cx="38.1336"
            cy="19.397"
            r="0.770436"
            transform="rotate(-141.388 38.1336 19.397)"
            fill="#61DFBD"
          />
          <circle
            cx="37.3631"
            cy="35.5759"
            r="0.770436"
            transform="rotate(-141.388 37.3631 35.5759)"
            fill="#61DFBD"
          />
          <circle
            cx="28.118"
            cy="40.1986"
            r="0.770436"
            transform="rotate(-141.388 28.118 40.1986)"
            fill="#61DFBD"
          />
          <circle
            cx="38.3553"
            cy="21.4151"
            r="0.770436"
            transform="rotate(32.1642 38.3553 21.4151)"
            fill="#61DFBD"
          />
          <circle
            cx="39.8964"
            cy="0.613512"
            r="0.770436"
            transform="rotate(32.1642 39.8964 0.613512)"
            fill="#61DFBD"
          />
          <circle
            cx="24.1356"
            cy="0.880602"
            r="0.770436"
            transform="rotate(32.1642 24.1356 0.880602)"
            fill="#61DFBD"
          />
          <circle
            cx="11.5597"
            cy="9.67485"
            r="0.770436"
            transform="rotate(127.774 11.5597 9.67485)"
            fill="#61DFBD"
          />
          <circle
            cx="34.7426"
            cy="9.99292"
            r="0.770436"
            transform="rotate(-13.614 34.7426 9.99292)"
            fill="#61DFBD"
          />
          <circle
            cx="33.9721"
            cy="26.173"
            r="0.770436"
            transform="rotate(-13.614 33.9721 26.173)"
            fill="#61DFBD"
          />
          <circle
            cx="43.2651"
            cy="22.3203"
            r="0.770436"
            transform="rotate(-13.614 43.2651 22.3203)"
            fill="#61DFBD"
          />
          <circle
            cx="38.642"
            cy="39.2704"
            r="0.770436"
            transform="rotate(-13.614 38.642 39.2704)"
            fill="#61DFBD"
          />
          <circle
            cx="37.101"
            cy="36.9597"
            r="0.770436"
            transform="rotate(-13.614 37.101 36.9597)"
            fill="#61DFBD"
          />
          <circle
            cx="34.7895"
            cy="22.3203"
            r="0.770436"
            transform="rotate(-13.614 34.7895 22.3203)"
            fill="#61DFBD"
          />
          <circle
            cx="36.3305"
            cy="16.9281"
            r="0.770436"
            transform="rotate(-13.614 36.3305 16.9281)"
            fill="#61DFBD"
          />
          <circle
            cx="24.727"
            cy="30.7951"
            r="0.770436"
            transform="rotate(-13.614 24.727 30.7951)"
            fill="#61DFBD"
          />
          <circle
            cx="42.7806"
            cy="30.3788"
            r="0.770436"
            transform="rotate(159.939 42.7806 30.3788)"
            fill="#61DFBD"
          />
          <circle
            cx="44.3216"
            cy="9.57669"
            r="0.770436"
            transform="rotate(159.939 44.3216 9.57669)"
            fill="#61DFBD"
          />
          <circle
            cx="32.765"
            cy="1.10251"
            r="0.770436"
            transform="rotate(159.939 32.765 1.10251)"
            fill="#61DFBD"
          />
          <circle
            cx="2.15254"
            cy="13.8805"
            r="0.770436"
            transform="rotate(173.859 2.15254 13.8805)"
            fill="#61DFBD"
          />
          <circle
            cx="33.9317"
            cy="0.250046"
            r="0.770436"
            transform="rotate(32.4707 33.9317 0.250046)"
            fill="#61DFBD"
          />
          <circle
            cx="39.5459"
            cy="16.2907"
            r="0.770436"
            transform="rotate(32.4707 39.5459 16.2907)"
            fill="#61DFBD"
          />
          <circle
            cx="43.9473"
            cy="28.7564"
            r="0.770436"
            transform="rotate(32.4707 43.9473 28.7564)"
            fill="#61DFBD"
          />
          <circle
            cx="34.7022"
            cy="33.379"
            r="0.770436"
            transform="rotate(32.4707 34.7022 33.379)"
            fill="#61DFBD"
          />
          <circle
            cx="32.5783"
            cy="28.9308"
            r="0.770436"
            transform="rotate(-153.977 32.5783 28.9308)"
            fill="#61DFBD"
          />
          <circle
            cx="33.3488"
            cy="7.01265"
            r="0.770436"
            transform="rotate(-153.977 33.3488 7.01265)"
            fill="#61DFBD"
          />
          <circle
            cx="22.5627"
            cy="-0.345561"
            r="0.770436"
            transform="rotate(-153.977 22.5627 -0.345561)"
            fill="#61DFBD"
          />
          <circle
            cx="4.64501"
            cy="3.19077"
            r="0.770436"
            transform="rotate(-58.3665 4.64501 3.19077)"
            fill="#61DFBD"
          />
          <circle
            cx="26.2446"
            cy="2.57484"
            r="0.770436"
            transform="rotate(-58.3665 26.2446 2.57484)"
            fill="#61DFBD"
          />
          <circle
            cx="37.0308"
            cy="13.3604"
            r="0.770436"
            transform="rotate(-58.3665 37.0308 13.3604)"
            fill="#61DFBD"
          />
          <circle
            cx="35.4897"
            cy="2.57484"
            r="0.770436"
            transform="rotate(-58.3665 35.4897 2.57484)"
            fill="#61DFBD"
          />
          <circle
            cx="5.37325"
            cy="1.61692"
            r="0.770436"
            transform="rotate(-173.648 5.37325 1.61692)"
            fill="#61DFBD"
          />
          <circle
            cx="43.9563"
            cy="19.9307"
            r="0.770436"
            transform="rotate(-173.648 43.9563 19.9307)"
            fill="#61DFBD"
          />
          <circle
            cx="37.7922"
            cy="29.1761"
            r="0.770436"
            transform="rotate(-173.648 37.7922 29.1761)"
            fill="#61DFBD"
          />
          <circle
            cx="38.5627"
            cy="32.2575"
            r="0.770436"
            transform="rotate(-173.648 38.5627 32.2575)"
            fill="#61DFBD"
          />
          <circle
            cx="43.1857"
            cy="26.2047"
            r="0.770436"
            transform="rotate(-173.648 43.1857 26.2047)"
            fill="#61DFBD"
          />
          <circle
            cx="20.0725"
            cy="6.17316"
            r="0.770436"
            transform="rotate(-173.648 20.0725 6.17316)"
            fill="#61DFBD"
          />
          <circle
            cx="19.2631"
            cy="9.08196"
            r="0.770436"
            transform="rotate(-3.1748 19.2631 9.08196)"
            fill="#61DFBD"
          />
          <circle
            cx="8.20059"
            cy="14.9"
            r="0.770436"
            transform="rotate(-3.1748 8.20059 14.9)"
            fill="#61DFBD"
          />
          <circle
            cx="23.8051"
            cy="13.1329"
            r="0.770436"
            transform="rotate(-3.1748 23.8051 13.1329)"
            fill="#61DFBD"
          />
          <circle
            cx="2.60099"
            cy="20.201"
            r="0.770436"
            transform="rotate(-3.1748 2.60099 20.201)"
            fill="#61DFBD"
          />
          <circle
            cx="7.90177"
            cy="25.502"
            r="0.770436"
            transform="rotate(-3.1748 7.90177 25.502)"
            fill="#61DFBD"
          />
          <circle
            cx="31.7572"
            cy="44.0558"
            r="0.770436"
            transform="rotate(-3.1748 31.7572 44.0558)"
            fill="#61DFBD"
          />
          <circle
            cx="43.8718"
            cy="41.3597"
            r="0.770436"
            transform="rotate(-102.547 43.8718 41.3597)"
            fill="#61DFBD"
          />
          <circle
            cx="23.5505"
            cy="42.2433"
            r="0.770436"
            transform="rotate(-102.547 23.5505 42.2433)"
            fill="#61DFBD"
          />
          <circle
            cx="6.43399"
            cy="14.0165"
            r="0.770436"
            transform="rotate(-3.1748 6.43399 14.0165)"
            fill="#61DFBD"
          />
          <circle
            cx="22.0385"
            cy="12.2493"
            r="0.770436"
            transform="rotate(-3.1748 22.0385 12.2493)"
            fill="#61DFBD"
          />
          <circle
            cx="0.833407"
            cy="19.3175"
            r="0.770436"
            transform="rotate(-3.1748 0.833407 19.3175)"
            fill="#61DFBD"
          />
          <circle
            cx="6.13516"
            cy="24.6184"
            r="0.770436"
            transform="rotate(-3.1748 6.13516 24.6184)"
            fill="#61DFBD"
          />
          <circle
            cx="44.1264"
            cy="10.4821"
            r="0.770436"
            transform="rotate(-3.1748 44.1264 10.4821)"
            fill="#61DFBD"
          />
          <circle
            cx="44.1264"
            cy="-0.119911"
            r="0.770436"
            transform="rotate(-3.1748 44.1264 -0.119911)"
            fill="#61DFBD"
          />
          <circle
            cx="29.9897"
            cy="43.1722"
            r="0.770436"
            transform="rotate(-3.1748 29.9897 43.1722)"
            fill="#61DFBD"
          />
          <circle
            cx="43.2878"
            cy="43.2475"
            r="0.770436"
            transform="rotate(-102.547 43.2878 43.2475)"
            fill="#61DFBD"
          />
          <circle
            cx="22.9675"
            cy="44.1311"
            r="0.770436"
            transform="rotate(-102.547 22.9675 44.1311)"
            fill="#61DFBD"
          />
          <circle
            cx="31.0986"
            cy="9.10927"
            r="0.770436"
            transform="rotate(86.4834 31.0986 9.10927)"
            fill="#61DFBD"
          />
          <circle
            cx="20.0725"
            cy="0.00973991"
            r="0.770436"
            transform="rotate(-173.648 20.0725 0.00973991)"
            fill="#61DFBD"
          />
          <circle
            cx="1.20927"
            cy="5.27899"
            r="0.770436"
            transform="rotate(132.57 1.20927 5.27899)"
            fill="#61DFBD"
          />
          <circle
            cx="9.42075"
            cy="3.88568"
            r="0.770436"
            transform="rotate(160.245 9.42075 3.88568)"
            fill="#61DFBD"
          />
          <circle
            cx="25.3143"
            cy="7.04767"
            r="0.770436"
            transform="rotate(160.245 25.3143 7.04767)"
            fill="#61DFBD"
          />
          <circle
            cx="36.1004"
            cy="19.3745"
            r="0.770436"
            transform="rotate(160.245 36.1004 19.3745)"
            fill="#61DFBD"
          />
          <circle
            cx="35.329"
            cy="35.554"
            r="0.770436"
            transform="rotate(160.245 35.329 35.554)"
            fill="#61DFBD"
          />
          <circle
            cx="26.0848"
            cy="40.1773"
            r="0.770436"
            transform="rotate(160.245 26.0848 40.1773)"
            fill="#61DFBD"
          />
          <circle
            cx="40.3781"
            cy="21.2086"
            r="0.770436"
            transform="rotate(-26.2023 40.3781 21.2086)"
            fill="#61DFBD"
          />
          <circle
            cx="41.9191"
            cy="0.406995"
            r="0.770436"
            transform="rotate(-26.2023 41.9191 0.406995)"
            fill="#61DFBD"
          />
          <circle
            cx="2.65301"
            cy="8.0438"
            r="0.770436"
            transform="rotate(-66.6947 2.65301 8.0438)"
            fill="#61DFBD"
          />
          <circle
            cx="4.08486"
            cy="0.892899"
            r="0.770436"
            transform="rotate(124.242 4.08486 0.892899)"
            fill="#61DFBD"
          />
          <circle
            cx="25.6845"
            cy="0.275773"
            r="0.770436"
            transform="rotate(124.242 25.6845 0.275773)"
            fill="#61DFBD"
          />
          <circle
            cx="36.4706"
            cy="11.0619"
            r="0.770436"
            transform="rotate(124.242 36.4706 11.0619)"
            fill="#61DFBD"
          />
          <circle
            cx="34.9306"
            cy="0.275773"
            r="0.770436"
            transform="rotate(124.242 34.9306 0.275773)"
            fill="#61DFBD"
          />
          <circle
            cx="3.53459"
            cy="3.10476"
            r="0.770436"
            transform="rotate(8.96039 3.53459 3.10476)"
            fill="#61DFBD"
          />
          <circle
            cx="42.4447"
            cy="20.7314"
            r="0.770436"
            transform="rotate(8.96039 42.4447 20.7314)"
            fill="#61DFBD"
          />
          <circle
            cx="36.2817"
            cy="29.9768"
            r="0.770436"
            transform="rotate(8.96039 36.2817 29.9768)"
            fill="#61DFBD"
          />
          <circle
            cx="40.1342"
            cy="42.4137"
            r="0.770436"
            transform="rotate(8.96039 40.1342 42.4137)"
            fill="#61DFBD"
          />
          <circle
            cx="41.6752"
            cy="27.7749"
            r="0.770436"
            transform="rotate(8.96039 41.6752 27.7749)"
            fill="#61DFBD"
          />
          <circle
            cx="17.7905"
            cy="6.86388"
            r="0.770436"
            transform="rotate(8.96039 17.7905 6.86388)"
            fill="#61DFBD"
          />
          <circle
            cx="20.4935"
            cy="7.28318"
            r="0.770436"
            transform="rotate(179.433 20.4935 7.28318)"
            fill="#61DFBD"
          />
          <circle
            cx="13.8362"
            cy="9.84217"
            r="0.770436"
            transform="rotate(179.433 13.8362 9.84217)"
            fill="#61DFBD"
          />
          <circle
            cx="6.6253"
            cy="11.9053"
            r="0.770436"
            transform="rotate(179.433 6.6253 11.9053)"
            fill="#61DFBD"
          />
          <circle
            cx="32.9046"
            cy="10.3289"
            r="0.770436"
            transform="rotate(-90.9085 32.9046 10.3289)"
            fill="#61DFBD"
          />
          <circle
            cx="18.5619"
            cy="1.58052"
            r="0.770436"
            transform="rotate(8.96039 18.5619 1.58052)"
            fill="#61DFBD"
          />
          <circle
            cx="8.73525"
            cy="2.17003"
            r="0.770436"
            transform="rotate(124.242 8.73525 2.17003)"
            fill="#61DFBD"
          />
          <circle
            cx="1.0585"
            cy="13.8804"
            r="0.770436"
            transform="rotate(124.242 1.0585 13.8804)"
            fill="#61DFBD"
          />
          <circle
            cx="30.3349"
            cy="1.55412"
            r="0.770436"
            transform="rotate(124.242 30.3349 1.55412)"
            fill="#61DFBD"
          />
          <circle
            cx="41.121"
            cy="12.3396"
            r="0.770436"
            transform="rotate(124.242 41.121 12.3396)"
            fill="#61DFBD"
          />
          <circle
            cx="38.0116"
            cy="1.65941"
            r="0.770436"
            transform="rotate(124.242 38.0116 1.65941)"
            fill="#61DFBD"
          />
          <circle
            cx="42.4447"
            cy="16.8794"
            r="0.770436"
            transform="rotate(8.96039 42.4447 16.8794)"
            fill="#61DFBD"
          />
          <circle
            cx="36.2817"
            cy="26.1236"
            r="0.770436"
            transform="rotate(8.96039 36.2817 26.1236)"
            fill="#61DFBD"
          />
          <path
            d="M40.5193 37.0297C40.453 37.45 40.0585 37.737 39.6382 37.6707C39.2179 37.6044 38.9309 37.21 38.9972 36.7897C39.0635 36.3694 39.4579 36.0824 39.8782 36.1487C40.2985 36.2149 40.5855 36.6094 40.5193 37.0297Z"
            fill="#61DFBD"
          />
          <path
            d="M42.0603 22.3915C41.994 22.8118 41.5996 23.0988 41.1792 23.0326C40.7589 22.9663 40.4719 22.5718 40.5382 22.1515C40.6045 21.7312 40.9989 21.4442 41.4192 21.5105C41.8395 21.5768 42.1265 21.9712 42.0603 22.3915Z"
            fill="#61DFBD"
          />
          <path
            d="M20.0925 1.58993C20.0262 2.01023 19.6318 2.29724 19.2115 2.23096C18.7912 2.16469 18.5042 1.77024 18.5704 1.34993C18.6367 0.929624 19.0312 0.642622 19.4515 0.708894C19.8718 0.775167 20.1588 1.16962 20.0925 1.58993Z"
            fill="#61DFBD"
          />
          <circle
            cx="16.0308"
            cy="0.645998"
            r="0.770436"
            transform="rotate(151.917 16.0308 0.645998)"
            fill="#61DFBD"
          />
          <circle
            cx="29.898"
            cy="4.49866"
            r="0.770436"
            transform="rotate(151.917 29.898 4.49866)"
            fill="#61DFBD"
          />
          <circle
            cx="40.6841"
            cy="16.8255"
            r="0.770436"
            transform="rotate(151.917 40.6841 16.8255)"
            fill="#61DFBD"
          />
          <circle
            cx="39.9136"
            cy="33.0044"
            r="0.770436"
            transform="rotate(151.917 39.9136 33.0044)"
            fill="#61DFBD"
          />
          <circle
            cx="30.6685"
            cy="37.627"
            r="0.770436"
            transform="rotate(151.917 30.6685 37.627)"
            fill="#61DFBD"
          />
          <circle
            cx="36.1095"
            cy="24.2563"
            r="0.770436"
            transform="rotate(-34.5305 36.1095 24.2563)"
            fill="#61DFBD"
          />
          <circle
            cx="37.6505"
            cy="3.45473"
            r="0.770436"
            transform="rotate(-34.5305 37.6505 3.45473)"
            fill="#61DFBD"
          />
          <circle
            cx="8.95115"
            cy="7.16214"
            r="0.770436"
            transform="rotate(61.0797 8.95115 7.16214)"
            fill="#61DFBD"
          />
          <circle
            cx="26.2739"
            cy="15.3468"
            r="0.770436"
            transform="rotate(-80.3087 26.2739 15.3468)"
            fill="#61DFBD"
          />
          <circle
            cx="35.2124"
            cy="13.5843"
            r="0.770436"
            transform="rotate(-80.3087 35.2124 13.5843)"
            fill="#61DFBD"
          />
          <circle
            cx="37.8305"
            cy="28.4437"
            r="0.770436"
            transform="rotate(-80.3087 37.8305 28.4437)"
            fill="#61DFBD"
          />
          <circle
            cx="25.1968"
            cy="34.3853"
            r="0.770436"
            transform="rotate(-80.3087 25.1968 34.3853)"
            fill="#61DFBD"
          />
          <circle
            cx="41.9108"
            cy="26.8629"
            r="0.770436"
            transform="rotate(93.2439 41.9108 26.8629)"
            fill="#61DFBD"
          />
          <circle
            cx="43.4509"
            cy="6.06133"
            r="0.770436"
            transform="rotate(93.2439 43.4509 6.06133)"
            fill="#61DFBD"
          />
          <circle
            cx="2.15467"
            cy="10.2584"
            r="0.770436"
            transform="rotate(107.164 2.15467 10.2584)"
            fill="#61DFBD"
          />
          <circle
            cx="7.16653"
            cy="-0.680249"
            r="0.770436"
            transform="rotate(-61.8992 7.16653 -0.680249)"
            fill="#61DFBD"
          />
          <circle
            cx="37.3814"
            cy="8.98284"
            r="0.770436"
            transform="rotate(-61.8992 37.3814 8.98284)"
            fill="#61DFBD"
          />
          <circle
            cx="1.26546"
            cy="3.16941"
            r="0.770436"
            transform="rotate(-177.181 1.26546 3.16941)"
            fill="#61DFBD"
          />
          <circle
            cx="34.6668"
            cy="29.9032"
            r="0.770436"
            transform="rotate(-177.181 34.6668 29.9032)"
            fill="#61DFBD"
          />
          <circle
            cx="37.7489"
            cy="42.3401"
            r="0.770436"
            transform="rotate(-177.181 37.7489 42.3401)"
            fill="#61DFBD"
          />
          <circle
            cx="39.2899"
            cy="27.7025"
            r="0.770436"
            transform="rotate(-177.181 39.2899 27.7025)"
            fill="#61DFBD"
          />
          <circle
            cx="16.1766"
            cy="7.67035"
            r="0.770436"
            transform="rotate(-177.181 16.1766 7.67035)"
            fill="#61DFBD"
          />
          <circle
            cx="22.8571"
            cy="6.96097"
            r="0.770436"
            transform="rotate(-6.70751 22.8571 6.96097)"
            fill="#61DFBD"
          />
          <circle
            cx="12.8415"
            cy="12.3543"
            r="0.770436"
            transform="rotate(-6.70751 12.8415 12.3543)"
            fill="#61DFBD"
          />
          <circle
            cx="8.98894"
            cy="11.5837"
            r="0.770436"
            transform="rotate(-6.70751 8.98894 11.5837)"
            fill="#61DFBD"
          />
          <circle
            cx="33.2411"
            cy="12.6907"
            r="0.770436"
            transform="rotate(82.9506 33.2411 12.6907)"
            fill="#61DFBD"
          />
          <circle
            cx="15.4061"
            cy="2.16699"
            r="0.770436"
            transform="rotate(-177.181 15.4061 2.16699)"
            fill="#61DFBD"
          />
          <circle
            cx="9.64505"
            cy="0.0909911"
            r="0.770436"
            transform="rotate(-61.8992 9.64505 0.0909911)"
            fill="#61DFBD"
          />
          <circle
            cx="1.96829"
            cy="11.8007"
            r="0.770436"
            transform="rotate(-61.8992 1.96829 11.8007)"
            fill="#61DFBD"
          />
          <circle
            cx="31.2447"
            cy="-0.526105"
            r="0.770436"
            transform="rotate(-61.8992 31.2447 -0.526105)"
            fill="#61DFBD"
          />
          <circle
            cx="42.0308"
            cy="10.26"
            r="0.770436"
            transform="rotate(-61.8992 42.0308 10.26)"
            fill="#61DFBD"
          />
          <circle
            cx="40.4898"
            cy="-0.526105"
            r="0.770436"
            transform="rotate(-61.8992 40.4898 -0.526105)"
            fill="#61DFBD"
          />
          <circle
            cx="40.8309"
            cy="16.8058"
            r="0.770436"
            transform="rotate(-177.181 40.8309 16.8058)"
            fill="#61DFBD"
          />
          <circle
            cx="34.6668"
            cy="26.0511"
            r="0.770436"
            transform="rotate(-177.181 34.6668 26.0511)"
            fill="#61DFBD"
          />
          <circle
            cx="37.7489"
            cy="36.9473"
            r="0.770436"
            transform="rotate(-177.181 37.7489 36.9473)"
            fill="#61DFBD"
          />
          <circle
            cx="39.2899"
            cy="22.3091"
            r="0.770436"
            transform="rotate(-177.181 39.2899 22.3091)"
            fill="#61DFBD"
          />
          <circle
            cx="16.9471"
            cy="2.93762"
            r="0.770436"
            transform="rotate(-177.181 16.9471 2.93762)"
            fill="#61DFBD"
          />
          <circle
            cx="1.00247"
            cy="29.3674"
            r="0.770436"
            transform="rotate(-61.8992 1.00247 29.3674)"
            fill="#61DFBD"
          />
          <circle
            cx="14.7235"
            cy="23.8413"
            r="0.770436"
            transform="rotate(168.337 14.7235 23.8413)"
            fill="#61DFBD"
          />
          <circle
            cx="26.2811"
            cy="11.5151"
            r="0.770436"
            transform="rotate(168.337 26.2811 11.5151)"
            fill="#61DFBD"
          />
          <circle
            cx="20.1171"
            cy="13.8259"
            r="0.770436"
            transform="rotate(168.337 20.1171 13.8259)"
            fill="#61DFBD"
          />
          <circle
            cx="29.2808"
            cy="14.7643"
            r="0.770436"
            transform="rotate(126.512 29.2808 14.7643)"
            fill="#61DFBD"
          />
          <circle
            cx="16.9536"
            cy="27.0911"
            r="0.770436"
            transform="rotate(126.512 16.9536 27.0911)"
            fill="#61DFBD"
          />
          <circle
            cx="3.85694"
            cy="32.4839"
            r="0.770436"
            transform="rotate(126.512 3.85694 32.4839)"
            fill="#61DFBD"
          />
          <circle
            cx="7.93704"
            cy="20.1219"
            r="0.770436"
            transform="rotate(-61.8992 7.93704 20.1219)"
            fill="#61DFBD"
          />
          <circle
            cx="23.5406"
            cy="18.3547"
            r="0.770436"
            transform="rotate(-61.8992 23.5406 18.3547)"
            fill="#61DFBD"
          />
          <circle
            cx="2.33646"
            cy="25.4229"
            r="0.770436"
            transform="rotate(-61.8992 2.33646 25.4229)"
            fill="#61DFBD"
          />
          <circle
            cx="4.01419"
            cy="28.3832"
            r="0.770436"
            transform="rotate(-61.8992 4.01419 28.3832)"
            fill="#61DFBD"
          />
          <circle
            cx="3.1825"
            cy="24.4249"
            r="0.770436"
            transform="rotate(168.337 3.1825 24.4249)"
            fill="#61DFBD"
          />
          <circle
            cx="14.7382"
            cy="12.0987"
            r="0.770436"
            transform="rotate(168.337 14.7382 12.0987)"
            fill="#61DFBD"
          />
          <circle
            cx="23.5417"
            cy="2.35652"
            r="0.770436"
            transform="rotate(-21.19 23.5417 2.35652)"
            fill="#61DFBD"
          />
          <circle
            cx="13.5271"
            cy="7.74928"
            r="0.770436"
            transform="rotate(-21.19 13.5271 7.74928)"
            fill="#61DFBD"
          />
          <circle
            cx="9.67456"
            cy="6.97923"
            r="0.770436"
            transform="rotate(-21.19 9.67456 6.97923)"
            fill="#61DFBD"
          />
          <circle
            cx="34.0886"
            cy="17.7678"
            r="0.770436"
            transform="rotate(68.4682 34.0886 17.7678)"
            fill="#61DFBD"
          />
          <circle
            cx="6.53211"
            cy="15.8819"
            r="0.770436"
            transform="rotate(168.337 6.53211 15.8819)"
            fill="#61DFBD"
          />
          <circle
            cx="22.1366"
            cy="14.1147"
            r="0.770436"
            transform="rotate(168.337 22.1366 14.1147)"
            fill="#61DFBD"
          />
          <circle
            cx="0.932497"
            cy="21.1829"
            r="0.770436"
            transform="rotate(168.337 0.932497 21.1829)"
            fill="#61DFBD"
          />
          <circle
            cx="6.23328"
            cy="26.4839"
            r="0.770436"
            transform="rotate(168.337 6.23328 26.4839)"
            fill="#61DFBD"
          />
          <circle
            cx="44.2245"
            cy="12.3475"
            r="0.770436"
            transform="rotate(168.337 44.2245 12.3475)"
            fill="#61DFBD"
          />
          <circle
            cx="44.2245"
            cy="1.74555"
            r="0.770436"
            transform="rotate(168.337 44.2245 1.74555)"
            fill="#61DFBD"
          />
          <circle
            cx="29.5887"
            cy="32.754"
            r="0.770436"
            transform="rotate(68.9645 29.5887 32.754)"
            fill="#61DFBD"
          />
          <circle
            cx="24.7909"
            cy="43.7301"
            r="0.770436"
            transform="rotate(68.9645 24.7909 43.7301)"
            fill="#61DFBD"
          />
          <circle
            cx="21.0698"
            cy="22.8955"
            r="0.770436"
            transform="rotate(126.512 21.0698 22.8955)"
            fill="#61DFBD"
          />
          <circle
            cx="8.74268"
            cy="35.223"
            r="0.770436"
            transform="rotate(126.512 8.74268 35.223)"
            fill="#61DFBD"
          />
          <circle
            cx="1.3638"
            cy="16.014"
            r="0.770436"
            transform="rotate(-61.8992 1.3638 16.014)"
            fill="#61DFBD"
          />
          <circle
            cx="6.4325"
            cy="30.7407"
            r="0.770436"
            transform="rotate(168.337 6.4325 30.7407)"
            fill="#61DFBD"
          />
          <circle
            cx="4.47038"
            cy="34.184"
            r="0.770436"
            transform="rotate(-127.86 4.47038 34.184)"
            fill="#61DFBD"
          />
          <circle
            cx="-0.831374"
            cy="22.6984"
            r="0.770436"
            transform="rotate(-127.86 -0.831374 22.6984)"
            fill="#61DFBD"
          />
          <circle
            cx="3.58659"
            cy="18.2804"
            r="0.770436"
            transform="rotate(-127.86 3.58659 18.2804)"
            fill="#61DFBD"
          />
          <circle
            cx="11.5378"
            cy="7.67841"
            r="0.770436"
            transform="rotate(-127.86 11.5378 7.67841)"
            fill="#61DFBD"
          />
          <circle
            cx="17.9891"
            cy="18.4133"
            r="0.770436"
            transform="rotate(168.337 17.9891 18.4133)"
            fill="#61DFBD"
          />
          <circle
            cx="20.6325"
            cy="39.1114"
            r="0.770436"
            transform="rotate(-127.86 20.6325 39.1114)"
            fill="#61DFBD"
          />
          <circle
            cx="15.3307"
            cy="27.6258"
            r="0.770436"
            transform="rotate(-127.86 15.3307 27.6258)"
            fill="#61DFBD"
          />
          <circle
            cx="19.7487"
            cy="23.2084"
            r="0.770436"
            transform="rotate(-127.86 19.7487 23.2084)"
            fill="#61DFBD"
          />
          <circle
            cx="9.35417"
            cy="18.7028"
            r="0.770436"
            transform="rotate(-127.86 9.35417 18.7028)"
            fill="#61DFBD"
          />
          <circle
            cx="24.9577"
            cy="16.9362"
            r="0.770436"
            transform="rotate(-127.86 24.9577 16.9362)"
            fill="#61DFBD"
          />
          <circle
            cx="3.75359"
            cy="24.0044"
            r="0.770436"
            transform="rotate(-127.86 3.75359 24.0044)"
            fill="#61DFBD"
          />
          <circle
            cx="9.05437"
            cy="29.3054"
            r="0.770436"
            transform="rotate(-127.86 9.05437 29.3054)"
            fill="#61DFBD"
          />
          <circle
            cx="27.9152"
            cy="33.7303"
            r="0.770436"
            transform="rotate(132.767 27.9152 33.7303)"
            fill="#61DFBD"
          />
          <circle
            cx="27.7009"
            cy="12.6058"
            r="0.770436"
            transform="rotate(-127.86 27.7009 12.6058)"
            fill="#61DFBD"
          />
          <circle
            cx="11.8261"
            cy="20.7252"
            r="0.770436"
            transform="rotate(168.337 11.8261 20.7252)"
            fill="#61DFBD"
          />
          <circle
            cx="15.8376"
            cy="34.6017"
            r="0.770436"
            transform="rotate(-127.86 15.8376 34.6017)"
            fill="#61DFBD"
          />
          <circle
            cx="10.5358"
            cy="23.1161"
            r="0.770436"
            transform="rotate(-127.86 10.5358 23.1161)"
            fill="#61DFBD"
          />
          <circle
            cx="14.9538"
            cy="18.6981"
            r="0.770436"
            transform="rotate(-127.86 14.9538 18.6981)"
            fill="#61DFBD"
          />
          <circle
            cx="5.23503"
            cy="15.1643"
            r="0.770436"
            transform="rotate(-127.86 5.23503 15.1643)"
            fill="#61DFBD"
          />
          <circle
            cx="20.8395"
            cy="13.3971"
            r="0.770436"
            transform="rotate(-127.86 20.8395 13.3971)"
            fill="#61DFBD"
          />
          <circle
            cx="-0.364577"
            cy="20.4653"
            r="0.770436"
            transform="rotate(-127.86 -0.364577 20.4653)"
            fill="#61DFBD"
          />
          <circle
            cx="4.9362"
            cy="25.7663"
            r="0.770436"
            transform="rotate(-127.86 4.9362 25.7663)"
            fill="#61DFBD"
          />
          <circle
            cx="42.9274"
            cy="11.6299"
            r="0.770436"
            transform="rotate(-127.86 42.9274 11.6299)"
            fill="#61DFBD"
          />
          <circle
            cx="42.9274"
            cy="1.0279"
            r="0.770436"
            transform="rotate(-127.86 42.9274 1.0279)"
            fill="#61DFBD"
          />
          <circle
            cx="28.7907"
            cy="44.32"
            r="0.770436"
            transform="rotate(-127.86 28.7907 44.32)"
            fill="#61DFBD"
          />
          <circle
            cx="44.6154"
            cy="44.2429"
            r="0.770436"
            transform="rotate(132.767 44.6154 44.2429)"
            fill="#61DFBD"
          />
          <circle
            cx="17.3136"
            cy="41.6821"
            r="0.770436"
            transform="rotate(132.767 17.3136 41.6821)"
            fill="#61DFBD"
          />
          <circle
            cx="22.9059"
            cy="8.0961"
            r="0.770436"
            transform="rotate(-127.86 22.9059 8.0961)"
            fill="#61DFBD"
          />
          <circle
            cx="27.7036"
            cy="25.434"
            r="0.770436"
            transform="rotate(126.512 27.7036 25.434)"
            fill="#61DFBD"
          />
          <circle
            cx="13.3204"
            cy="39.4413"
            r="0.770436"
            transform="rotate(-169.685 13.3204 39.4413)"
            fill="#61DFBD"
          />
          <circle
            cx="17.7374"
            cy="35.0239"
            r="0.770436"
            transform="rotate(-169.685 17.7374 35.0239)"
            fill="#61DFBD"
          />
          <circle
            cx="8.01962"
            cy="31.4895"
            r="0.770436"
            transform="rotate(-169.685 8.01962 31.4895)"
            fill="#61DFBD"
          />
          <circle
            cx="25.6895"
            cy="24.4213"
            r="0.770436"
            transform="rotate(-169.685 25.6895 24.4213)"
            fill="#61DFBD"
          />
          <circle
            cx="15.3765"
            cy="37.7614"
            r="0.770436"
            transform="rotate(126.512 15.3765 37.7614)"
            fill="#61DFBD"
          />
          <circle
            cx="1.23446"
            cy="29.4052"
            r="0.770436"
            transform="rotate(-169.685 1.23446 29.4052)"
            fill="#61DFBD"
          />
          <circle
            cx="10.0518"
            cy="15.8677"
            r="0.770436"
            transform="rotate(-169.685 10.0518 15.8677)"
            fill="#61DFBD"
          />
          <circle
            cx="25.6563"
            cy="14.1005"
            r="0.770436"
            transform="rotate(-169.685 25.6563 14.1005)"
            fill="#61DFBD"
          />
          <circle
            cx="4.45223"
            cy="21.1687"
            r="0.770436"
            transform="rotate(-169.685 4.45223 21.1687)"
            fill="#61DFBD"
          />
          <circle
            cx="-0.849524"
            cy="18.5179"
            r="0.770436"
            transform="rotate(-169.685 -0.849524 18.5179)"
            fill="#61DFBD"
          />
          <circle
            cx="9.16903"
            cy="21.1687"
            r="0.770436"
            transform="rotate(-169.685 9.16903 21.1687)"
            fill="#61DFBD"
          />
          <circle
            cx="44.5246"
            cy="39.3759"
            r="0.770436"
            transform="rotate(90.9424 44.5246 39.3759)"
            fill="#61DFBD"
          />
          <circle
            cx="24.2043"
            cy="40.2595"
            r="0.770436"
            transform="rotate(90.9424 24.2043 40.2595)"
            fill="#61DFBD"
          />
          <circle
            cx="2.27882"
            cy="43.1536"
            r="0.770436"
            transform="rotate(126.512 2.27882 43.1536)"
            fill="#61DFBD"
          />
          <circle
            cx="13.586"
            cy="15.8677"
            r="0.770436"
            transform="rotate(-169.685 13.586 15.8677)"
            fill="#61DFBD"
          />
          <circle
            cx="8.15555"
            cy="24.6022"
            r="0.770436"
            transform="rotate(1.90357 8.15555 24.6022)"
            fill="#61DFBD"
          />
          <circle
            cx="9.95145"
            cy="13.1166"
            r="0.770436"
            transform="rotate(1.90357 9.95145 13.1166)"
            fill="#61DFBD"
          />
          <circle
            cx="25.5559"
            cy="11.3494"
            r="0.770436"
            transform="rotate(1.90357 25.5559 11.3494)"
            fill="#61DFBD"
          />
          <circle
            cx="4.35184"
            cy="18.4176"
            r="0.770436"
            transform="rotate(1.90357 4.35184 18.4176)"
            fill="#61DFBD"
          />
          <circle
            cx="9.65262"
            cy="23.7186"
            r="0.770436"
            transform="rotate(1.90357 9.65262 23.7186)"
            fill="#61DFBD"
          />
          <circle
            cx="33.5071"
            cy="42.2724"
            r="0.770436"
            transform="rotate(1.90357 33.5071 42.2724)"
            fill="#61DFBD"
          />
          <circle
            cx="29.4577"
            cy="39.6903"
            r="0.770436"
            transform="rotate(-97.469 29.4577 39.6903)"
            fill="#61DFBD"
          />
          <circle
            cx="41.8268"
            cy="39.9232"
            r="0.770436"
            transform="rotate(-97.469 41.8268 39.9232)"
            fill="#61DFBD"
          />
          <circle
            cx="21.5065"
            cy="40.8068"
            r="0.770436"
            transform="rotate(-97.469 21.5065 40.8068)"
            fill="#61DFBD"
          />
          <circle
            cx="44.4772"
            cy="31.9714"
            r="0.770436"
            transform="rotate(-97.469 44.4772 31.9714)"
            fill="#61DFBD"
          />
          <circle
            cx="7.27176"
            cy="8.69859"
            r="0.770436"
            transform="rotate(1.90357 7.27176 8.69859)"
            fill="#61DFBD"
          />
          <circle
            cx="10.9716"
            cy="28.9688"
            r="0.770436"
            transform="rotate(168.337 10.9716 28.9688)"
            fill="#61DFBD"
          />
          <circle
            cx="8.06316"
            cy="37.4742"
            r="0.770436"
            transform="rotate(-127.86 8.06316 37.4742)"
            fill="#61DFBD"
          />
          <circle
            cx="-0.364577"
            cy="24.8874"
            r="0.770436"
            transform="rotate(-127.86 -0.364577 24.8874)"
            fill="#61DFBD"
          />
          <circle
            cx="7.17937"
            cy="21.5712"
            r="0.770436"
            transform="rotate(-127.86 7.17937 21.5712)"
            fill="#61DFBD"
          />
          <circle
            cx="22.7839"
            cy="19.8041"
            r="0.770436"
            transform="rotate(-127.86 22.7839 19.8041)"
            fill="#61DFBD"
          />
          <circle
            cx="1.57976"
            cy="26.8722"
            r="0.770436"
            transform="rotate(-127.86 1.57976 26.8722)"
            fill="#61DFBD"
          />
          <circle
            cx="3.1696"
            cy="30.189"
            r="0.770436"
            transform="rotate(-127.86 3.1696 30.189)"
            fill="#61DFBD"
          />
          <circle
            cx="44.8717"
            cy="18.0368"
            r="0.770436"
            transform="rotate(-127.86 44.8717 18.0368)"
            fill="#61DFBD"
          />
          <circle
            cx="44.8717"
            cy="7.43488"
            r="0.770436"
            transform="rotate(-127.86 44.8717 7.43488)"
            fill="#61DFBD"
          />
          <circle
            cx="27.9152"
            cy="38.1477"
            r="0.770436"
            transform="rotate(132.767 27.9152 38.1477)"
            fill="#61DFBD"
          />
          <circle
            cx="30.299"
            cy="42.1645"
            r="0.770436"
            transform="rotate(132.767 30.299 42.1645)"
            fill="#61DFBD"
          />
          <circle
            cx="15.1315"
            cy="10.9687"
            r="0.770436"
            transform="rotate(-127.86 15.1315 10.9687)"
            fill="#61DFBD"
          />
          <circle
            cx="22.5282"
            cy="16.642"
            r="0.770436"
            transform="rotate(168.337 22.5282 16.642)"
            fill="#61DFBD"
          />
          <circle
            cx="22.6061"
            cy="37.2571"
            r="0.770436"
            transform="rotate(-127.86 22.6061 37.2571)"
            fill="#61DFBD"
          />
          <circle
            cx="18.9245"
            cy="30.9161"
            r="0.770436"
            transform="rotate(-127.86 18.9245 30.9161)"
            fill="#61DFBD"
          />
          <circle
            cx="23.3425"
            cy="26.4987"
            r="0.770436"
            transform="rotate(-127.86 23.3425 26.4987)"
            fill="#61DFBD"
          />
          <circle
            cx="13.6237"
            cy="22.9643"
            r="0.770436"
            transform="rotate(-127.86 13.6237 22.9643)"
            fill="#61DFBD"
          />
          <circle
            cx="31.2946"
            cy="15.8961"
            r="0.770436"
            transform="rotate(-127.86 31.2946 15.8961)"
            fill="#61DFBD"
          />
          <circle
            cx="16.3641"
            cy="18.9527"
            r="0.770436"
            transform="rotate(168.337 16.3641 18.9527)"
            fill="#61DFBD"
          />
          <circle
            cx="19.4313"
            cy="37.8913"
            r="0.770436"
            transform="rotate(-127.86 19.4313 37.8913)"
            fill="#61DFBD"
          />
          <circle
            cx="14.1296"
            cy="26.4057"
            r="0.770436"
            transform="rotate(-127.86 14.1296 26.4057)"
            fill="#61DFBD"
          />
          <circle
            cx="18.5475"
            cy="21.9883"
            r="0.770436"
            transform="rotate(-127.86 18.5475 21.9883)"
            fill="#61DFBD"
          />
          <circle
            cx="6.70378"
            cy="17.8198"
            r="0.770436"
            transform="rotate(-127.86 6.70378 17.8198)"
            fill="#61DFBD"
          />
          <circle
            cx="22.3073"
            cy="16.0526"
            r="0.770436"
            transform="rotate(-127.86 22.3073 16.0526)"
            fill="#61DFBD"
          />
          <circle
            cx="1.1032"
            cy="23.1208"
            r="0.770436"
            transform="rotate(-127.86 1.1032 23.1208)"
            fill="#61DFBD"
          />
          <circle
            cx="6.40398"
            cy="28.4218"
            r="0.770436"
            transform="rotate(-127.86 6.40398 28.4218)"
            fill="#61DFBD"
          />
          <circle
            cx="44.3952"
            cy="14.2854"
            r="0.770436"
            transform="rotate(-127.86 44.3952 14.2854)"
            fill="#61DFBD"
          />
          <circle
            cx="44.3952"
            cy="3.68341"
            r="0.770436"
            transform="rotate(-127.86 44.3952 3.68341)"
            fill="#61DFBD"
          />
          <circle
            cx="26.6759"
            cy="43.2458"
            r="0.770436"
            transform="rotate(132.767 26.6759 43.2458)"
            fill="#61DFBD"
          />
          <circle
            cx="26.4997"
            cy="11.3857"
            r="0.770436"
            transform="rotate(-127.86 26.4997 11.3857)"
            fill="#61DFBD"
          />
          <circle
            cx="29.9038"
            cy="21.0871"
            r="0.770436"
            transform="rotate(126.512 29.9038 21.0871)"
            fill="#61DFBD"
          />
          <circle
            cx="18.1925"
            cy="39.4966"
            r="0.770436"
            transform="rotate(-169.685 18.1925 39.4966)"
            fill="#61DFBD"
          />
          <circle
            cx="22.6104"
            cy="35.0792"
            r="0.770436"
            transform="rotate(-169.685 22.6104 35.0792)"
            fill="#61DFBD"
          />
          <circle
            cx="12.8917"
            cy="31.5454"
            r="0.770436"
            transform="rotate(-169.685 12.8917 31.5454)"
            fill="#61DFBD"
          />
          <circle
            cx="30.5616"
            cy="24.4772"
            r="0.770436"
            transform="rotate(-169.685 30.5616 24.4772)"
            fill="#61DFBD"
          />
          <circle
            cx="17.5767"
            cy="33.414"
            r="0.770436"
            transform="rotate(126.512 17.5767 33.414)"
            fill="#61DFBD"
          />
          <circle
            cx="1.68954"
            cy="33.8779"
            r="0.770436"
            transform="rotate(-169.685 1.68954 33.8779)"
            fill="#61DFBD"
          />
          <circle
            cx="6.10751"
            cy="29.46"
            r="0.770436"
            transform="rotate(-169.685 6.10751 29.46)"
            fill="#61DFBD"
          />
          <circle
            cx="14.0587"
            cy="18.858"
            r="0.770436"
            transform="rotate(-169.685 14.0587 18.858)"
            fill="#61DFBD"
          />
          <circle
            cx="4.47901"
            cy="38.8068"
            r="0.770436"
            transform="rotate(126.512 4.47901 38.8068)"
            fill="#61DFBD"
          />
          <circle
            cx="17.8028"
            cy="-0.772786"
            r="0.770436"
            transform="rotate(-34.224 17.8028 -0.772786)"
            fill="#61DFBD"
          />
          <circle
            cx="40.3157"
            cy="2.42314"
            r="0.770436"
            transform="rotate(147.632 40.3157 2.42314)"
            fill="#61DFBD"
          />
          <circle
            cx="31.67"
            cy="3.07984"
            r="0.770436"
            transform="rotate(-34.224 31.67 3.07984)"
            fill="#61DFBD"
          />
          <circle
            cx="34.1592"
            cy="5.51179"
            r="0.770436"
            transform="rotate(-34.224 34.1592 5.51179)"
            fill="#61DFBD"
          />
          <circle
            cx="41.6856"
            cy="31.5856"
            r="0.770436"
            transform="rotate(-34.224 41.6856 31.5856)"
            fill="#61DFBD"
          />
          <circle
            cx="32.4405"
            cy="36.2083"
            r="0.770436"
            transform="rotate(-34.224 32.4405 36.2083)"
            fill="#61DFBD"
          />
          <circle
            cx="31.8647"
            cy="26.3298"
            r="0.770436"
            transform="rotate(139.329 31.8647 26.3298)"
            fill="#61DFBD"
          />
          <circle
            cx="36.0483"
            cy="5.06406"
            r="0.770436"
            transform="rotate(139.329 36.0483 5.06406)"
            fill="#61DFBD"
          />
          <circle
            cx="7.50641"
            cy="5.41086"
            r="0.770436"
            transform="rotate(-125.061 7.50641 5.41086)"
            fill="#61DFBD"
          />
          <circle
            cx="10.5945"
            cy="-0.324682"
            r="0.770436"
            transform="rotate(93.5504 10.5945 -0.324682)"
            fill="#61DFBD"
          />
          <circle
            cx="6.17064"
            cy="9.11074"
            r="0.770436"
            transform="rotate(93.5504 6.17064 9.11074)"
            fill="#61DFBD"
          />
          <circle
            cx="0.777082"
            cy="6.79879"
            r="0.770436"
            transform="rotate(93.5504 0.777082 6.79879)"
            fill="#61DFBD"
          />
          <circle
            cx="2.90501"
            cy="15.7877"
            r="0.770436"
            transform="rotate(93.5504 2.90501 15.7877)"
            fill="#61DFBD"
          />
          <circle
            cx="42.9812"
            cy="9.8449"
            r="0.770436"
            transform="rotate(93.5504 42.9812 9.8449)"
            fill="#61DFBD"
          />
          <circle
            cx="40.2539"
            cy="19.3101"
            r="0.770436"
            transform="rotate(-21.7309 40.2539 19.3101)"
            fill="#61DFBD"
          />
          <circle
            cx="34.0898"
            cy="28.5556"
            r="0.770436"
            transform="rotate(-21.7309 34.0898 28.5556)"
            fill="#61DFBD"
          />
          <circle
            cx="36.4013"
            cy="40.2229"
            r="0.770436"
            transform="rotate(-21.7309 36.4013 40.2229)"
            fill="#61DFBD"
          />
          <circle
            cx="37.9423"
            cy="25.5841"
            r="0.770436"
            transform="rotate(-21.7309 37.9423 25.5841)"
            fill="#61DFBD"
          />
          <circle
            cx="14.8291"
            cy="5.5532"
            r="0.770436"
            transform="rotate(-21.7309 14.8291 5.5532)"
            fill="#61DFBD"
          />
          <circle
            cx="14.8291"
            cy="-0.610798"
            r="0.770436"
            transform="rotate(-21.7309 14.8291 -0.610798)"
            fill="#61DFBD"
          />
          <circle
            cx="23.1199"
            cy="6.02874"
            r="0.770436"
            transform="rotate(93.5504 23.1199 6.02874)"
            fill="#61DFBD"
          />
          <circle
            cx="35.2488"
            cy="15.8542"
            r="0.770436"
            transform="rotate(93.5504 35.2488 15.8542)"
            fill="#61DFBD"
          />
          <circle
            cx="34.6765"
            cy="31.453"
            r="0.770436"
            transform="rotate(93.5504 34.6765 31.453)"
            fill="#61DFBD"
          />
          <circle
            cx="25.2331"
            cy="36.6564"
            r="0.770436"
            transform="rotate(93.5504 25.2331 36.6564)"
            fill="#61DFBD"
          />
          <circle
            cx="41.6192"
            cy="24.6112"
            r="0.770436"
            transform="rotate(-92.897 41.6192 24.6112)"
            fill="#61DFBD"
          />
          <circle
            cx="36.9795"
            cy="6.79046"
            r="0.770436"
            transform="rotate(-92.897 36.9795 6.79046)"
            fill="#61DFBD"
          />
          <circle
            cx="-0.039134"
            cy="8.29516"
            r="0.770436"
            fill="#61DFBD"
          />
          <circle
            cx="6.77644"
            cy="1.15641"
            r="0.770436"
            transform="rotate(-169.064 6.77644 1.15641)"
            fill="#61DFBD"
          />
          <circle
            cx="-0.900317"
            cy="12.8673"
            r="0.770436"
            transform="rotate(-169.064 -0.900317 12.8673)"
            fill="#61DFBD"
          />
          <circle
            cx="28.377"
            cy="0.539895"
            r="0.770436"
            transform="rotate(-169.064 28.377 0.539895)"
            fill="#61DFBD"
          />
          <circle
            cx="39.1622"
            cy="11.3266"
            r="0.770436"
            transform="rotate(-169.064 39.1622 11.3266)"
            fill="#61DFBD"
          />
          <circle
            cx="37.6212"
            cy="0.539895"
            r="0.770436"
            transform="rotate(-169.064 37.6212 0.539895)"
            fill="#61DFBD"
          />
          <circle
            cx="2.62318"
            cy="0.558483"
            r="0.770436"
            transform="rotate(75.6551 2.62318 0.558483)"
            fill="#61DFBD"
          />
          <circle
            cx="41.9161"
            cy="19.0487"
            r="0.770436"
            transform="rotate(75.6551 41.9161 19.0487)"
            fill="#61DFBD"
          />
          <circle
            cx="35.7521"
            cy="28.2941"
            r="0.770436"
            transform="rotate(75.6551 35.7521 28.2941)"
            fill="#61DFBD"
          />
          <circle
            cx="38.6486"
            cy="39.3885"
            r="0.770436"
            transform="rotate(75.6551 38.6486 39.3885)"
            fill="#61DFBD"
          />
          <circle
            cx="40.1896"
            cy="24.7497"
            r="0.770436"
            transform="rotate(75.6551 40.1896 24.7497)"
            fill="#61DFBD"
          />
          <circle
            cx="17.0763"
            cy="4.71879"
            r="0.770436"
            transform="rotate(75.6551 17.0763 4.71879)"
            fill="#61DFBD"
          />
          <circle
            cx="11.4268"
            cy="2.43415"
            r="0.770436"
            transform="rotate(-169.064 11.4268 2.43415)"
            fill="#61DFBD"
          />
          <circle
            cx="21.0741"
            cy="3.98352"
            r="0.770436"
            transform="rotate(-141.388 21.0741 3.98352)"
            fill="#61DFBD"
          />
          <circle
            cx="39.5685"
            cy="3.98642"
            r="0.770436"
            transform="rotate(40.4674 39.5685 3.98642)"
            fill="#61DFBD"
          />
          <circle
            cx="32.159"
            cy="5.98248"
            r="0.770436"
            transform="rotate(-141.388 32.159 5.98248)"
            fill="#61DFBD"
          />
          <circle
            cx="42.9452"
            cy="18.3093"
            r="0.770436"
            transform="rotate(-141.388 42.9452 18.3093)"
            fill="#61DFBD"
          />
          <circle
            cx="42.1747"
            cy="34.4888"
            r="0.770436"
            transform="rotate(-141.388 42.1747 34.4888)"
            fill="#61DFBD"
          />
          <circle
            cx="32.9295"
            cy="39.1115"
            r="0.770436"
            transform="rotate(-141.388 32.9295 39.1115)"
            fill="#61DFBD"
          />
          <circle
            cx="33.6962"
            cy="23.0358"
            r="0.770436"
            transform="rotate(32.1642 33.6962 23.0358)"
            fill="#61DFBD"
          />
          <circle
            cx="35.2372"
            cy="2.23421"
            r="0.770436"
            transform="rotate(32.1642 35.2372 2.23421)"
            fill="#61DFBD"
          />
          <circle
            cx="22.5946"
            cy="4.73265"
            r="0.770436"
            transform="rotate(32.1642 22.5946 4.73265)"
            fill="#61DFBD"
          />
          <circle
            cx="10.4025"
            cy="4.8792"
            r="0.770436"
            transform="rotate(127.774 10.4025 4.8792)"
            fill="#61DFBD"
          />
          <circle
            cx="9.36568"
            cy="5.37198"
            r="0.770436"
            transform="rotate(-13.614 9.36568 5.37198)"
            fill="#61DFBD"
          />
          <circle
            cx="0.32369"
            cy="9.99408"
            r="0.770436"
            transform="rotate(-13.614 0.32369 9.99408)"
            fill="#61DFBD"
          />
          <circle
            cx="40.3862"
            cy="8.45279"
            r="0.770436"
            transform="rotate(-13.614 40.3862 8.45279)"
            fill="#61DFBD"
          />
          <circle
            cx="-0.496435"
            cy="0.678549"
            r="0.770436"
            transform="rotate(-128.895 -0.496435 0.678549)"
            fill="#61DFBD"
          />
          <circle
            cx="39.5661"
            cy="17.851"
            r="0.770436"
            transform="rotate(-128.895 39.5661 17.851)"
            fill="#61DFBD"
          />
          <circle
            cx="33.402"
            cy="27.097"
            r="0.770436"
            transform="rotate(-128.895 33.402 27.097)"
            fill="#61DFBD"
          />
          <circle
            cx="34.943"
            cy="38.7644"
            r="0.770436"
            transform="rotate(-128.895 34.943 38.7644)"
            fill="#61DFBD"
          />
          <circle
            cx="36.484"
            cy="24.1262"
            r="0.770436"
            transform="rotate(-128.895 36.484 24.1262)"
            fill="#61DFBD"
          />
          <circle
            cx="14.1413"
            cy="4.75475"
            r="0.770436"
            transform="rotate(-128.895 14.1413 4.75475)"
            fill="#61DFBD"
          />
          <circle
            cx="26.2154"
            cy="10.0236"
            r="0.770436"
            transform="rotate(41.5777 26.2154 10.0236)"
            fill="#61DFBD"
          />
          <circle
            cx="16.1998"
            cy="15.4164"
            r="0.770436"
            transform="rotate(41.5777 16.1998 15.4164)"
            fill="#61DFBD"
          />
          <circle
            cx="11.1275"
            cy="14.2922"
            r="0.770436"
            transform="rotate(41.5777 11.1275 14.2922)"
            fill="#61DFBD"
          />
          <circle
            cx="26.7311"
            cy="12.525"
            r="0.770436"
            transform="rotate(41.5777 26.7311 12.525)"
            fill="#61DFBD"
          />
          <circle
            cx="5.52696"
            cy="19.5932"
            r="0.770436"
            transform="rotate(41.5777 5.52696 19.5932)"
            fill="#61DFBD"
          />
          <circle
            cx="0.226174"
            cy="16.9424"
            r="0.770436"
            transform="rotate(41.5777 0.226174 16.9424)"
            fill="#61DFBD"
          />
          <circle
            cx="10.8287"
            cy="24.8942"
            r="0.770436"
            transform="rotate(41.5777 10.8287 24.8942)"
            fill="#61DFBD"
          />
          <circle
            cx="34.6832"
            cy="43.4479"
            r="0.770436"
            transform="rotate(41.5777 34.6832 43.4479)"
            fill="#61DFBD"
          />
          <circle
            cx="18.3926"
            cy="44.261"
            r="0.770436"
            transform="rotate(-57.7949 18.3926 44.261)"
            fill="#61DFBD"
          />
          <circle
            cx="19.9375"
            cy="41.656"
            r="0.770436"
            transform="rotate(-57.7949 19.9375 41.656)"
            fill="#61DFBD"
          />
          <circle
            cx="36.6104"
            cy="44.7563"
            r="0.770436"
            transform="rotate(-57.7949 36.6104 44.7563)"
            fill="#61DFBD"
          />
          <circle
            cx="42.7959"
            cy="38.5717"
            r="0.770436"
            transform="rotate(-57.7949 42.7959 38.5717)"
            fill="#61DFBD"
          />
          <circle
            cx="22.4746"
            cy="39.4553"
            r="0.770436"
            transform="rotate(-57.7949 22.4746 39.4553)"
            fill="#61DFBD"
          />
          <circle
            cx="30.1989"
            cy="16.0681"
            r="0.770436"
            transform="rotate(131.236 30.1989 16.0681)"
            fill="#61DFBD"
          />
          <circle
            cx="21.8686"
            cy="2.13525"
            r="0.770436"
            transform="rotate(-13.614 21.8686 2.13525)"
            fill="#61DFBD"
          />
          <circle
            cx="32.6547"
            cy="14.4626"
            r="0.770436"
            transform="rotate(-13.614 32.6547 14.4626)"
            fill="#61DFBD"
          />
          <circle
            cx="31.8842"
            cy="30.6421"
            r="0.770436"
            transform="rotate(-13.614 31.8842 30.6421)"
            fill="#61DFBD"
          />
          <circle
            cx="22.6391"
            cy="35.2643"
            r="0.770436"
            transform="rotate(-13.614 22.6391 35.2643)"
            fill="#61DFBD"
          />
          <circle
            cx="44.3538"
            cy="25.7032"
            r="0.770436"
            transform="rotate(159.939 44.3538 25.7032)"
            fill="#61DFBD"
          />
          <circle
            cx="30.9954"
            cy="5.42932"
            r="0.770436"
            transform="rotate(159.939 30.9954 5.42932)"
            fill="#61DFBD"
          />
          <circle
            cx="4.80489"
            cy="9.72076"
            r="0.770436"
            transform="rotate(173.859 4.80489 9.72076)"
            fill="#61DFBD"
          />
          <circle
            cx="28.7598"
            cy="3.1938"
            r="0.770436"
            transform="rotate(32.4707 28.7598 3.1938)"
            fill="#61DFBD"
          />
          <circle
            cx="40.0489"
            cy="14.1729"
            r="0.770436"
            transform="rotate(32.4707 40.0489 14.1729)"
            fill="#61DFBD"
          />
          <circle
            cx="39.2784"
            cy="30.3518"
            r="0.770436"
            transform="rotate(32.4707 39.2784 30.3518)"
            fill="#61DFBD"
          />
          <circle
            cx="30.0332"
            cy="34.9745"
            r="0.770436"
            transform="rotate(32.4707 30.0332 34.9745)"
            fill="#61DFBD"
          />
          <circle
            cx="37.9719"
            cy="27.8143"
            r="0.770436"
            transform="rotate(-153.977 37.9719 27.8143)"
            fill="#61DFBD"
          />
          <circle
            cx="38.5793"
            cy="6.01906"
            r="0.770436"
            transform="rotate(-153.977 38.5793 6.01906)"
            fill="#61DFBD"
          />
          <circle
            cx="6.30907"
            cy="7.83582"
            r="0.770436"
            transform="rotate(-58.3665 6.30907 7.83582)"
            fill="#61DFBD"
          />
          <circle
            cx="0.457317"
            cy="0.403315"
            r="0.770436"
            transform="rotate(132.57 0.457317 0.403315)"
            fill="#61DFBD"
          />
          <circle
            cx="27.1405"
            cy="0.804263"
            r="0.770436"
            transform="rotate(160.245 27.1405 0.804263)"
            fill="#61DFBD"
          />
          <circle
            cx="37.6981"
            cy="14.7071"
            r="0.770436"
            transform="rotate(160.245 37.6981 14.7071)"
            fill="#61DFBD"
          />
          <circle
            cx="36.9276"
            cy="30.8866"
            r="0.770436"
            transform="rotate(160.245 36.9276 30.8866)"
            fill="#61DFBD"
          />
          <circle
            cx="27.6825"
            cy="35.5087"
            r="0.770436"
            transform="rotate(160.245 27.6825 35.5087)"
            fill="#61DFBD"
          />
          <circle
            cx="39.3137"
            cy="26.026"
            r="0.770436"
            transform="rotate(-26.2023 39.3137 26.026)"
            fill="#61DFBD"
          />
          <circle
            cx="40.8547"
            cy="5.22386"
            r="0.770436"
            transform="rotate(-26.2023 40.8547 5.22386)"
            fill="#61DFBD"
          />
          <circle
            cx="4.97235"
            cy="12.3983"
            r="0.770436"
            transform="rotate(-66.6947 4.97235 12.3983)"
            fill="#61DFBD"
          />
          <circle
            cx="11.7886"
            cy="0.86133"
            r="0.770436"
            transform="rotate(151.917 11.7886 0.86133)"
            fill="#61DFBD"
          />
          <circle
            cx="30.8033"
            cy="-0.351133"
            r="0.770436"
            transform="rotate(151.917 30.8033 -0.351133)"
            fill="#61DFBD"
          />
          <circle
            cx="42.0054"
            cy="14.2465"
            r="0.770436"
            transform="rotate(151.917 42.0054 14.2465)"
            fill="#61DFBD"
          />
          <circle
            cx="40.8189"
            cy="28.1552"
            r="0.770436"
            transform="rotate(151.917 40.8189 28.1552)"
            fill="#61DFBD"
          />
          <circle
            cx="31.5738"
            cy="32.7779"
            r="0.770436"
            transform="rotate(151.917 31.5738 32.7779)"
            fill="#61DFBD"
          />
          <circle
            cx="27.2267"
            cy="19.3807"
            r="0.770436"
            transform="rotate(-34.5305 27.2267 19.3807)"
            fill="#61DFBD"
          />
          <circle
            cx="37.2951"
            cy="8.37511"
            r="0.770436"
            transform="rotate(-34.5305 37.2951 8.37511)"
            fill="#61DFBD"
          />
          <circle
            cx="25.7394"
            cy="-0.0996512"
            r="0.770436"
            transform="rotate(-34.5305 25.7394 -0.0996512)"
            fill="#61DFBD"
          />
          <circle
            cx="4.08982"
            cy="6.32736"
            r="0.770436"
            transform="rotate(61.0797 4.08982 6.32736)"
            fill="#61DFBD"
          />
          <circle
            cx="2.34941"
            cy="2.30491"
            r="0.770436"
            transform="rotate(-107.984 2.34941 2.30491)"
            fill="#61DFBD"
          />
          <circle
            cx="13.8374"
            cy="1.0916"
            r="0.770436"
            transform="rotate(-80.3087 13.8374 1.0916)"
            fill="#61DFBD"
          />
          <circle
            cx="27.7046"
            cy="4.94365"
            r="0.770436"
            transform="rotate(-80.3087 27.7046 4.94365)"
            fill="#61DFBD"
          />
          <circle
            cx="38.4907"
            cy="17.2711"
            r="0.770436"
            transform="rotate(-80.3087 38.4907 17.2711)"
            fill="#61DFBD"
          />
          <circle
            cx="37.7212"
            cy="33.45"
            r="0.770436"
            transform="rotate(-80.3087 37.7212 33.45)"
            fill="#61DFBD"
          />
          <circle
            cx="28.4751"
            cy="38.0726"
            r="0.770436"
            transform="rotate(-80.3087 28.4751 38.0726)"
            fill="#61DFBD"
          />
          <circle
            cx="38.239"
            cy="23.568"
            r="0.770436"
            transform="rotate(93.2439 38.239 23.568)"
            fill="#61DFBD"
          />
          <circle
            cx="39.78"
            cy="2.7658"
            r="0.770436"
            transform="rotate(93.2439 39.78 2.7658)"
            fill="#61DFBD"
          />
          <circle
            cx="-0.61681"
            cy="6.17688"
            r="0.770436"
            transform="rotate(107.164 -0.61681 6.17688)"
            fill="#61DFBD"
          />
          <circle
            cx="6.94193"
            cy="3.34593"
            r="0.770436"
            transform="rotate(-61.8992 6.94193 3.34593)"
            fill="#61DFBD"
          />
          <circle
            cx="-0.735809"
            cy="15.0557"
            r="0.770436"
            transform="rotate(-61.8992 -0.735809 15.0557)"
            fill="#61DFBD"
          />
          <circle
            cx="25.6568"
            cy="3.94304"
            r="0.770436"
            transform="rotate(-61.8992 25.6568 3.94304)"
            fill="#61DFBD"
          />
          <circle
            cx="39.3277"
            cy="13.5156"
            r="0.770436"
            transform="rotate(-61.8992 39.3277 13.5156)"
            fill="#61DFBD"
          />
          <circle
            cx="33.3618"
            cy="3.17241"
            r="0.770436"
            transform="rotate(-61.8992 33.3618 3.17241)"
            fill="#61DFBD"
          />
          <circle
            cx="4.53304"
            cy="-0.525571"
            r="0.770436"
            transform="rotate(-177.181 4.53304 -0.525571)"
            fill="#61DFBD"
          />
          <circle
            cx="31.5848"
            cy="20.6572"
            r="0.770436"
            transform="rotate(-177.181 31.5848 20.6572)"
            fill="#61DFBD"
          />
          <circle
            cx="31.5848"
            cy="21.4279"
            r="0.770436"
            transform="rotate(-177.181 31.5848 21.4279)"
            fill="#61DFBD"
          />
          <circle
            cx="40.8309"
            cy="38.4886"
            r="0.770436"
            transform="rotate(-177.181 40.8309 38.4886)"
            fill="#61DFBD"
          />
          <circle
            cx="42.3709"
            cy="23.8498"
            r="0.770436"
            transform="rotate(-177.181 42.3709 23.8498)"
            fill="#61DFBD"
          />
          <circle
            cx="19.2586"
            cy="3.81827"
            r="0.770436"
            transform="rotate(-177.181 19.2586 3.81827)"
            fill="#61DFBD"
          />
          <circle
            cx="17.4209"
            cy="4.1464"
            r="0.770436"
            transform="rotate(-34.224 17.4209 4.1464)"
            fill="#61DFBD"
          />
          <circle
            cx="22.2134"
            cy="10.6424"
            r="0.770436"
            transform="rotate(136.249 22.2134 10.6424)"
            fill="#61DFBD"
          />
          <circle
            cx="11.1294"
            cy="16.9441"
            r="0.770436"
            transform="rotate(136.249 11.1294 16.9441)"
            fill="#61DFBD"
          />
          <circle
            cx="26.733"
            cy="15.1769"
            r="0.770436"
            transform="rotate(136.249 26.733 15.1769)"
            fill="#61DFBD"
          />
          <circle
            cx="5.52886"
            cy="22.245"
            r="0.770436"
            transform="rotate(136.249 5.52886 22.245)"
            fill="#61DFBD"
          />
          <circle
            cx="10.8296"
            cy="27.5466"
            r="0.770436"
            transform="rotate(136.249 10.8296 27.5466)"
            fill="#61DFBD"
          />
          <circle
            cx="21.0094"
            cy="43.8272"
            r="0.770436"
            transform="rotate(36.8764 21.0094 43.8272)"
            fill="#61DFBD"
          />
          <circle
            cx="39.2272"
            cy="44.3226"
            r="0.770436"
            transform="rotate(36.8764 39.2272 44.3226)"
            fill="#61DFBD"
          />
          <circle
            cx="24.3708"
            cy="38.138"
            r="0.770436"
            transform="rotate(36.8764 24.3708 38.138)"
            fill="#61DFBD"
          />
          <circle
            cx="8.47808"
            cy="16.9441"
            r="0.770436"
            transform="rotate(136.249 8.47808 16.9441)"
            fill="#61DFBD"
          />
          <circle
            cx="24.0826"
            cy="15.1769"
            r="0.770436"
            transform="rotate(136.249 24.0826 15.1769)"
            fill="#61DFBD"
          />
          <circle
            cx="2.87847"
            cy="22.245"
            r="0.770436"
            transform="rotate(136.249 2.87847 22.245)"
            fill="#61DFBD"
          />
          <circle
            cx="8.17925"
            cy="27.5466"
            r="0.770436"
            transform="rotate(136.249 8.17925 27.5466)"
            fill="#61DFBD"
          />
          <circle
            cx="25.5231"
            cy="41.6365"
            r="0.770436"
            transform="rotate(36.8764 25.5231 41.6365)"
            fill="#61DFBD"
          />
          <circle
            cx="29.5563"
            cy="12.0693"
            r="0.770436"
            transform="rotate(-134.093 29.5563 12.0693)"
            fill="#61DFBD"
          />
          <circle
            cx="29.5371"
            cy="7.0525"
            r="0.770436"
            transform="rotate(-34.224 29.5371 7.0525)"
            fill="#61DFBD"
          />
          <circle
            cx="41.3037"
            cy="36.5042"
            r="0.770436"
            transform="rotate(-34.224 41.3037 36.5042)"
            fill="#61DFBD"
          />
          <circle
            cx="32.0586"
            cy="41.1269"
            r="0.770436"
            transform="rotate(-34.224 32.0586 41.1269)"
            fill="#61DFBD"
          />
          <circle
            cx="34.3344"
            cy="20.9353"
            r="0.770436"
            transform="rotate(139.329 34.3344 20.9353)"
            fill="#61DFBD"
          />
          <circle
            cx="35.7163"
            cy="-0.635185"
            r="0.770436"
            transform="rotate(139.329 35.7163 -0.635185)"
            fill="#61DFBD"
          />
          <circle
            cx="26.4712"
            cy="6.29829"
            r="0.770436"
            transform="rotate(139.329 26.4712 6.29829)"
            fill="#61DFBD"
          />
          <circle
            cx="12.4302"
            cy="5.72089"
            r="0.770436"
            transform="rotate(-125.061 12.4302 5.72089)"
            fill="#61DFBD"
          />
          <circle
            cx="24.9336"
            cy="5.53051"
            r="0.770436"
            transform="rotate(45.4118 24.9336 5.53051)"
            fill="#61DFBD"
          />
          <circle
            cx="17.2295"
            cy="12.4646"
            r="0.770436"
            transform="rotate(45.4118 17.2295 12.4646)"
            fill="#61DFBD"
          />
          <circle
            cx="10.2949"
            cy="9.38256"
            r="0.770436"
            transform="rotate(45.4118 10.2949 9.38256)"
            fill="#61DFBD"
          />
          <circle
            cx="31.9612"
            cy="16.7153"
            r="0.770436"
            transform="rotate(135.07 31.9612 16.7153)"
            fill="#61DFBD"
          />
          <circle
            cx="22.3493"
            cy="3.7174"
            r="0.770436"
            transform="rotate(93.5504 22.3493 3.7174)"
            fill="#61DFBD"
          />
          <circle
            cx="31.5945"
            cy="12.5392"
            r="0.770436"
            transform="rotate(93.5504 31.5945 12.5392)"
            fill="#61DFBD"
          />
          <circle
            cx="30.0534"
            cy="29.1417"
            r="0.770436"
            transform="rotate(93.5504 30.0534 29.1417)"
            fill="#61DFBD"
          />
          <circle
            cx="21.5788"
            cy="33.3414"
            r="0.770436"
            transform="rotate(93.5504 21.5788 33.3414)"
            fill="#61DFBD"
          />
          <circle
            cx="30.8155"
            cy="23.7406"
            r="0.770436"
            transform="rotate(-92.897 30.8155 23.7406)"
            fill="#61DFBD"
          />
          <circle
            cx="35.4385"
            cy="11.4132"
            r="0.770436"
            transform="rotate(-92.897 35.4385 11.4132)"
            fill="#61DFBD"
          />
          <circle
            cx="18.794"
            cy="13.869"
            r="0.770436"
            transform="rotate(-34.224 18.794 13.869)"
            fill="#A788FF"
          />
          <circle
            cx="16.4825"
            cy="6.93553"
            r="0.770436"
            transform="rotate(-34.224 16.4825 6.93553)"
            fill="#A788FF"
          />
          <circle
            cx="13.4004"
            cy="3.85469"
            r="0.770436"
            transform="rotate(-34.224 13.4004 3.85469)"
            fill="#A788FF"
          />
          <circle
            cx="36.5137"
            cy="-0.766256"
            r="0.770436"
            transform="rotate(-34.224 36.5137 -0.766256)"
            fill="#A788FF"
          />
          <circle
            cx="44.2178"
            cy="4.62712"
            r="0.770436"
            transform="rotate(-34.224 44.2178 4.62712)"
            fill="#A788FF"
          />
          <circle
            cx="41.1358"
            cy="5.39717"
            r="0.770436"
            transform="rotate(-34.224 41.1358 5.39717)"
            fill="#A788FF"
          />
          <circle
            cx="41.1358"
            cy="23.8874"
            r="0.770436"
            transform="rotate(-34.224 41.1358 23.8874)"
            fill="#A788FF"
          />
          <circle
            cx="44.2178"
            cy="29.2807"
            r="0.770436"
            transform="rotate(-34.224 44.2178 29.2807)"
            fill="#A788FF"
          />
          <circle
            cx="41.1358"
            cy="33.9035"
            r="0.770436"
            transform="rotate(-34.224 41.1358 33.9035)"
            fill="#A788FF"
          />
          <circle
            cx="8.77836"
            cy="0.00321455"
            r="0.770436"
            transform="rotate(-34.224 8.77836 0.00321455)"
            fill="#A788FF"
          />
          <circle
            cx="18.794"
            cy="3.08464"
            r="0.770436"
            transform="rotate(-34.224 18.794 3.08464)"
            fill="#A788FF"
          />
          <circle
            cx="24.5039"
            cy="8.59202"
            r="0.770436"
            transform="rotate(-34.224 24.5039 8.59202)"
            fill="#F3836A"
          />
          <circle
            cx="22.1924"
            cy="0.888468"
            r="0.770436"
            transform="rotate(-34.224 22.1924 0.888468)"
            fill="#F3836A"
          />
          <circle
            cx="39.9131"
            cy="1.65913"
            r="0.770436"
            transform="rotate(-34.224 39.9131 1.65913)"
            fill="#F3836A"
          />
          <circle
            cx="33.75"
            cy="7.82255"
            r="0.770436"
            transform="rotate(-34.224 33.75 7.82255)"
            fill="#F3836A"
          />
          <circle
            cx="19.1114"
            cy="0.889079"
            r="0.770436"
            transform="rotate(-34.224 19.1114 0.889079)"
            fill="#F3836A"
          />
          <circle
            cx="14.4883"
            cy="4.74171"
            r="0.770436"
            transform="rotate(-34.224 14.4883 4.74171)"
            fill="#F3836A"
          />
          <circle
            cx="30.668"
            cy="1.65913"
            r="0.770436"
            transform="rotate(-34.224 30.668 1.65913)"
            fill="#F3836A"
          />
          <circle
            cx="42.9952"
            cy="3.97166"
            r="0.770436"
            transform="rotate(-34.224 42.9952 3.97166)"
            fill="#F3836A"
          />
          <circle
            cx="42.2237"
            cy="25.5433"
            r="0.770436"
            transform="rotate(-34.224 42.2237 25.5433)"
            fill="#F3836A"
          />
          <circle
            cx="39.9131"
            cy="17.8392"
            r="0.770436"
            transform="rotate(-34.224 39.9131 17.8392)"
            fill="#F3836A"
          />
          <circle
            cx="37.6016"
            cy="10.1339"
            r="0.770436"
            transform="rotate(-34.224 37.6016 10.1339)"
            fill="#F3836A"
          />
          <circle
            cx="32.9785"
            cy="20.1499"
            r="0.770436"
            transform="rotate(-34.224 32.9785 20.1499)"
            fill="#F3836A"
          />
          <circle
            cx="28.3565"
            cy="10.1339"
            r="0.770436"
            transform="rotate(-34.224 28.3565 10.1339)"
            fill="#F3836A"
          />
          <circle
            cx="7.55472"
            cy="4.74171"
            r="0.770436"
            transform="rotate(-34.224 7.55472 4.74171)"
            fill="#F3836A"
          />
          <circle
            cx="12.9473"
            cy="27.0846"
            r="0.770436"
            transform="rotate(-34.224 12.9473 27.0846)"
            fill="#F3836A"
          />
          <circle
            cx="42.9952"
            cy="35.5588"
            r="0.770436"
            transform="rotate(-34.224 42.9952 35.5588)"
            fill="#F3836A"
          />
          <circle
            cx="38.3721"
            cy="33.2474"
            r="0.770436"
            transform="rotate(-34.224 38.3721 33.2474)"
            fill="#F3836A"
          />
          <circle
            cx="39.1426"
            cy="39.4114"
            r="0.770436"
            transform="rotate(-34.224 39.1426 39.4114)"
            fill="#F3836A"
          />
          <circle
            cx="42.2237"
            cy="34.0181"
            r="0.770436"
            transform="rotate(-34.224 42.2237 34.0181)"
            fill="#F3836A"
          />
          <circle
            cx="25.2745"
            cy="-0.652639"
            r="0.770436"
            transform="rotate(-34.224 25.2745 -0.652639)"
            fill="#FFCB57"
          />
          <circle
            cx="15.2588"
            cy="2.42994"
            r="0.770436"
            transform="rotate(-34.224 15.2588 2.42994)"
            fill="#FFCB57"
          />
          <circle
            cx="23.7334"
            cy="3.19999"
            r="0.770436"
            transform="rotate(-34.224 23.7334 3.19999)"
            fill="#FFCB57"
          />
          <circle
            cx="22.9639"
            cy="1.65989"
            r="0.770436"
            transform="rotate(-34.224 22.9639 1.65989)"
            fill="#FFCB57"
          />
          <circle
            cx="20.6524"
            cy="-0.652059"
            r="0.770436"
            transform="rotate(-34.224 20.6524 -0.652059)"
            fill="#FFCB57"
          />
          <circle
            cx="29.127"
            cy="2.42994"
            r="0.770436"
            transform="rotate(-34.224 29.127 2.42994)"
            fill="#FFCB57"
          />
          <circle
            cx="27.586"
            cy="4.74131"
            r="0.770436"
            transform="rotate(-34.224 27.586 4.74131)"
            fill="#FFCB57"
          />
          <circle
            cx="42.9952"
            cy="1.65989"
            r="0.770436"
            transform="rotate(-34.224 42.9952 1.65989)"
            fill="#FFCB57"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3108_3886">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
